// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSpinner_loader__Z8ONC","spin":"LoadingSpinner_spin__XnuOF"};